if($('.auth-page-body').length){
    $('.auth-page-body .form-control').each(function (e) {
        if ($(this).val() && $(this).val().length) {
            $(this).next().css({bottom:'89%', fontSize:'.75rem'});
        }
    })

    $(document).on('input' , '.auth-page-body .form-control', function () {
        if($(this).val().length){
            $(this).next().css({bottom:'89%', fontSize:'.75rem'});
        }
        else{
            $(this).next().css({bottom:'89%', fontSize:'.75rem'});
        }
    })
    $(document).on('focus' , '.auth-page-body .form-control', function () {
        if(!$(this).val() || !$(this).val().length){
            $(this).next().css({bottom:'89%', fontSize:'.75rem'});
        }
    })
    $(document).on('blur' , '.auth-page-body .form-control', function () {
        if($(this).val().length){
            $(this).next().css({bottom:'89%', fontSize:'.75rem'});
        }
        else{
            $(this).next().css({bottom:'.5rem', fontSize:'.875rem'});
        }
    })
}
